<template>
    <div class="modal fade" id="provide-vin-modal">
      <div class="modal-dialog modal-dialog-centered rounded-0">
          <div class="modal-content">
            <form @submit.prevent="submitVin">
              <div class="modal-header">
                <h5 class="modal-title">{{ modalTitle }}</h5>
                <button type="button" class="btn-close" aria-label="Close" @click="closeModal"></button>
              </div>
              <div class="modal-body">
                <input type="text" style="height: 45px" class="form-control rounded-0" v-model="providedVIN" :minlength="vinLength" :maxlength="vinLength" :placeholder="vinPlaceholder">
                <div class="text-end"><span class="text-muted" style="font-size: 10px">{{ providedVIN.length }} / 17</span></div>
              </div>
              <div class="modal-footer">
                <button type="submit" class="btn btn-primary text-dark" :disabled="providedVIN.length != 17">Submit VIN</button>
              </div>
            </form>
          </div>
      </div>
    </div>
</template>

<script lang="js">

import { Modal } from 'bootstrap'
import appConstants from '@/constants/app.constants';
import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import Mixin from '../mixins/global.mixin'

export default {
  name: 'ProvideVinModalComponent',
  mixins: [Mixin],
  computed: mapState([
    'currentSessionEmail',
    'origin'
  ]),
  setup() {
    return {
        appConstants: appConstants
    }
  },
  watch: {
    isOpen(value) {
      if (value) {
        console.log('test');
        this.openModal();
      } else {
        this.closeModal();
      }
    },
    providedVIN: function (newVal) {
      this.providedVIN = this.cleanVinNumber(newVal);
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    modalTitle: {
      type: String,
      default: "Submit 17-Digit VIN",
    },
    orderNumber: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    orderSKU: {
      type: Number,
      required: true
    },
    vinLength: {
      type: Number,
      default: 17,
    },
    vinPlaceholder: {
      type: String,
      default: "17 Digit Vehicle VIN"
    },
    vinProvided: {
      required: true,
      default: []
    }
  },
  data() {
    return {
      providedVIN: "",
      provideVINModal: null,
    }
  },
  methods: {
    openModal() {
      const modalElement = document.getElementById('provide-vin-modal');
      const modalInstance = new Modal(modalElement);
      modalInstance.show();
    },
    closeModal() {
      const modalElement = document.getElementById('provide-vin-modal');
      const modalInstance = Modal.getInstance(modalElement);
      modalInstance.hide();
      this.$emit("update:isOpen", false); // Update parent state
    },
    submitVin: async function () {
      this.closeModal();
      try {
        this.toggleFullScreenSpinner(true);
        
        let orderNotes = appConstants.NOTE_TEXT+' for Order #'+this.orderNumber+(this.origin ? ' via '+this.origin.toUpperCase() : '')+" | VIN: "+this.providedVIN+" - SKU: "+this.orderSKU;
        let trackerData = {
          "vin_tracker": {
              "order_number": this.orderNumber,
              "order_id": this.orderId,
              "origin": this.origin ? this.origin : 'Portal',
              "site": appConstants.SITEURL.toLocaleLowerCase().includes('tipm') ? 'tipm' : 'ecm',
              "vin": this.providedVIN,
              "message": orderNotes
          }
        }
        const results = await Promise.all([
          this.submitToDatabase(trackerData),
          this.submitToWoocommerce(orderNotes, this.orderId),
          this.sendSlackNotification(this.orderNumber, this.providedVIN, this.orderSKU),
          this.updateWooCommerceOrder(this.orderId, this.providedVIN)
          //this.submitToShipstation(this.orderNumber, this.providedVIN, this.orderSKU)
        ]);
        await this.afterComplete(results);
      } catch (error) {
        console.error('Error running functions:', error);
      }
    },
    afterComplete: async function (results) {
      this.toggleFullScreenSpinner(false);
      if (results[0] && results[1] && results[2] && results[3]) {
        Swal.fire({
          position: "center-center",
          icon: "success",
          html: "<strong>VIN has been submitted</strong>",
          showConfirmButton: false,
          timer: 1500
        });
        this.$emit("update:vinProvided", results[0]);
      }
    },
  },
  mounted() {
    this.provideVINModal = new Modal(document.getElementById('provide-vin-modal'));
    if (this.isOpen) {
        this.provideVINModal.show();
    }
  }
}
</script>